export default __webpack_public_path__ + "static/media/KOD0009-min.418e741c.webp";